/**
 * Utility functions for data layer
 */
export const initDataLayerUtils = () => {
    // Expose these functions globally for use in inline scripts
    window.rockwellUtils = {
        addVal: (obj, key, value, delimiter) => {
            if (value != null && value.length > 0) {
                obj[key] = delimiter != null ? value.split(delimiter) : value;
            }
        },

        setCookie: (name, value, days) => {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "")  + expires + "; path=/;secure";
        },

        getCookie: (name) => {
            var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            if (match && match[2]) return match[2];
            return '';
        },

        getLocalTimestamp: () => {
            var now = new Date();
            var year = now.getFullYear();
            var month = ("0" + (now.getMonth() + 1)).slice(-2);
            var day = ("0" + now.getDate()).slice(-2);
            var hour = ("0" + now.getHours()).slice(-2);
            var min = ("0" + now.getMinutes()).slice(-2);
            var sec = ("0" + now.getSeconds()).slice(-2);
            return year + "-" + month + "-" + day + "T" + hour + ":" + min + ":" + sec;
        }
    };
};
